import { WrapperCircularLoader } from './styles';

function CircularLoader({ color = 'white', scale = '1' }) {
  return (
    <WrapperCircularLoader style={{ color, transform: `scale(${scale})` }}>
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
      <div style={{ backgroundColor: color }} />
    </WrapperCircularLoader>
  );
}

export default CircularLoader;
